import { getPlantDetails, getUserAllowedPlants } from '../services/PlantServices';
import { getBgImageLogo } from '../services/LoginServices';
import { fetchImageDataUrl } from './pdfMedia';

function resolvePrimaryPlantId(plantIds) {
  if (!Array.isArray(plantIds) || !plantIds.length) {
    return null;
  }
  const firstId = Number(plantIds[0]);
  return Number.isFinite(firstId) ? firstId : null;
}

export async function buildListExcelExportHeader(cookies, plantIds = [], options = {}) {
  const plantId = resolvePrimaryPlantId(plantIds);
  let companyName = '';
  let plantAlias = '';
  let addressLines = [];
  let gstNo = '';
  let logoPath = '';

  if (plantId) {
    try {
      const plant = await getPlantDetails(cookies, plantId);
      companyName = plant.entity_name || '';
      plantAlias = plant.plant_alias || plant.alias_name || '';
      const line1 = [plant.address_1, plant.address_2].filter(Boolean).join(', ');
      const line2 = [plant.address_3, plant.state, plant.pincode].filter(Boolean).join(' - ');
      addressLines = [line1, line2].filter(Boolean);
      gstNo = plant.gst_no || '';
      logoPath = plant.plant_logo || '';
    } catch (error) {
      // Fall back to company list below.
    }
  }

  if (!plantAlias && plantId) {
    try {
      const plantList = await getUserAllowedPlants(cookies);
      const match = (plantList.plant_list || []).find((plant) => Number(plant.id) === plantId);
      plantAlias = match?.plant_alias || match?.alias_name || '';
      if (!companyName) {
        companyName = match?.entity_name || '';
      }
    } catch (error) {
      // Optional plant alias lookup.
    }
  }

  if (!companyName || !logoPath) {
    try {
      const response = await getBgImageLogo();
      const company = (response.company_list || []).find((item) => item.status)
        || response.company_list?.[0];
      if (company) {
        if (!companyName) {
          companyName = company.name || '';
        }
        logoPath = logoPath || company.logo || '';
      }
    } catch (error) {
      // Header can render without logo.
    }
  }

  if (!companyName) {
    companyName = options.fallbackCompanyName || 'Company';
  }

  const logoDataUrl = logoPath
    ? await fetchImageDataUrl(cookies, logoPath).catch(() => null)
    : null;

  const infoLines = [];
  if (plantAlias) {
    infoLines.push(`Plant: ${plantAlias}`);
  }
  (options.extraInfoLines || []).filter(Boolean).forEach((line) => infoLines.push(line));

  return {
    companyName,
    plantAlias,
    addressLines,
    gstNo,
    logoDataUrl,
    infoLines,
    documentTitle: options.documentTitle || 'Report',
  };
}
